<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :rules="rules" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shop_id">
                <el-select
                  v-model="queryForm.shop_id"
                  filterable
                  remote
                  clearable
                  :remote-method="remoteShopMethod"
                  placeholder="请输入店铺">
                    <el-option
                      v-for="item in shopList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单号:" prop="orderId">
                <el-input v-model="queryForm.orderId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="linkmanTel">
                <el-input v-model="queryForm.linkmanTel" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="退款方:" prop="responsibility">
                <el-select v-model="queryForm.responsibility" placeholder="请选择">
                    <el-option label="暂无" value="0"></el-option>
                    <el-option label="俺来也" value="1"></el-option>
                    <el-option label="商家" value="2"></el-option>
                    <!--<el-option label="西游侠责任" value="3"></el-option>-->
                    <el-option label="无" value="4"></el-option>
                    <el-option label="校园ceo" value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop="">
                <el-select v-model="dateType" placeholder="请选择" @change="changeDateType(dateType)">
                    <el-option label="申请时间" :value="1"></el-option>
                    <el-option label="退款完成时间" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop="startDate" v-if="dateType == 1">
                <el-col :span="11">
                    <el-date-picker size="small" type="date" placeholder="开始时间" v-model="queryForm.startDate1" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="t-c" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker size="small" type="date" placeholder="结束时间" v-model="queryForm.endDate1" style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="" prop="refundStartDate" v-if="dateType == 2">
                <el-col :span="11">
                    <el-date-picker size="small" type="date" value-format="yyyyMMdd" placeholder="开始时间" v-model="queryForm.refundStartDate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="t-c" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker size="small" type="date" value-format="yyyyMMdd" placeholder="结束时间" v-model="queryForm.refundEndDate" style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="退款结果:" prop="needRefund">
                <el-select v-model="queryForm.needRefund" placeholder="请选择">
                    <el-option label="无需退款" value="0"></el-option>
                    <el-option label="需要退款" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="退款原因:" prop="reasonCode">
                <el-select v-model="queryForm.reasonCode" placeholder="请选择">
                    <el-option label="配送时间太长" value="4004"></el-option>
                    <el-option label="点错或不想要了" value="4006"></el-option>
                    <el-option label="商家缺货或已打烊" value="4007"></el-option>
                    <el-option label="需要改餐品、时间或地址" value="4010"></el-option>
                    <el-option label="少做、做错商品" value="4003"></el-option>
                    <el-option label="撒漏、包装损坏" value="4001"></el-option>
                    <el-option label="未收到餐" value="4011"></el-option>
                    <el-option label="商品卫生质量问题" value="4002"></el-option>
                    <el-option label="配送员提前点击已送达" value="4008"></el-option>
                    <el-option label="配送员送错订单" value="4009"></el-option>
                    <el-option label="其他原因" value="4005"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审批状态:" prop="approveStatus">
                <el-select v-model="queryForm.approveStatus" placeholder="请选择">
                    <el-option label="商家待审核" value="990"></el-option>
                    <el-option label="商家逾期未处理" value="1010"></el-option>
                    <el-option label="商家审核完毕" value="1005"></el-option>
                    <el-option label="校园经理待审核" value="1000"></el-option>
                    <el-option label="校园经理审核完毕" value="2000"></el-option>
                    <el-option label="校园经理逾期未处理" value="2001"></el-option>
                    <el-option label="城市经理审核完毕" value="3000"></el-option>
                    <el-option label="已取消" value="9000"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否退款申诉:" prop="isAppeal">
                <el-select v-model="queryForm.isAppeal" placeholder="请选择">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData(queryForm.pageNo=1)">搜索</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <div>
                <export-excel :params="exportParams" :action="$apiUrl.adminreFundlist" :target="'oc'" :field="fieldName" :fieldname="tableTitle" :filename="filename"></export-excel>
            </div>
        </el-row>

        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="orderId"
                    label="订单号"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="logTransId"
                    label="交易号"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="schoolName"
                    label="学校名称"
                    :show-overflow-tooltip="true"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="supplierShortName"
                    label="店铺名称"
                    :show-overflow-tooltip="true"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="userName"
                    label="用户名"
                    :show-overflow-tooltip="true"
                    width="110">
            </el-table-column>
            <el-table-column
                    prop="linkmanTel"
                    label="用户手机"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="refundType"
                    label="退款类型"
                    width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.refundType==1">全部商品</span>
                    <span v-if="scope.row.refundType==2">部分商品</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="reason"
                    label="退款原因"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="complaintContent"
                    label="详细描述"
                    :show-overflow-tooltip="true"
                    width="200">
            </el-table-column>
            <el-table-column
                    prop="approveStatus"
                    label="审核状态"
                    width="150">
                <template slot-scope="scope">
                    <span v-if="scope.row.approveStatus==990">商家待审核</span>
                    <span v-if="scope.row.approveStatus==1010">商家逾期未处理</span>
                    <span v-if="scope.row.approveStatus==1005 || scope.row.approveStatus==3005">商家审核完毕</span>
                    <span v-if="scope.row.approveStatus==1000">校园经理待审核</span>
                    <span v-if="scope.row.approveStatus==2000">校园经理审核完毕</span>
                    <span v-if="scope.row.approveStatus==2001">校园经理逾期未处理</span>
                    <span v-if="scope.row.approveStatus==3000">城市经理审核完</span>
                    <span v-if="scope.row.approveStatus==9000">已取消</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="responsibilityIdentification"
                    label="退款方"
                    width="90">
                <template slot-scope="scope">
                    <span v-if="scope.row.responsibilityIdentification==0">暂无</span>
                    <span v-if="scope.row.responsibilityIdentification==1">俺来也</span>
                    <span v-if="scope.row.responsibilityIdentification==2">商家</span>
                    <!--<span v-if="scope.row.responsibilityIdentification==3">西游侠责任</span>-->
                    <span v-if="scope.row.responsibilityIdentification==4">无</span>
                    <span v-if="scope.row.responsibilityIdentification==5">校园ceo</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="auditingResult"
                    label="退款结果"
                    width="90">
                <template slot-scope="scope">
                    <span v-if="scope.row.auditingResult==0">无</span>
                    <span v-if="scope.row.auditingResult==1">无需退款</span>
                    <span v-if="scope.row.auditingResult==2">需要退款</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="refundAmount"
                label="申请金额"
                :show-overflow-tooltip="true"
                width="90">
            </el-table-column>
            <el-table-column
                    prop="realRefundAmount"
                    label="退款金额"
                    width="90">
            </el-table-column>
            <el-table-column
                    prop="cutDeliveryFee"
                    label="配送费扣除"
                    width="130">
                <template slot-scope="scope">
                    <span>{{scope.row.cutDeliveryFee?scope.row.cutDeliveryFee:'—'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="settlePrice"
                    label="商家结算款扣除"
                    width="130">
                <template slot-scope="scope">
                    <span>{{scope.row.settlePrice?scope.row.settlePrice:'—'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="申请退款时间"
                    width="160">
                <template slot-scope="scope">
                    <span>{{$utils.formatDate(scope.row.createTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="refundDate"
                    label="退款完成日期"
                    width="100">
                <template slot-scope="scope">
                    <span>{{$utils.formatDate1(scope.row.refundDate)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="orderCreateTime"
                    label="下单时间"
                    width="160">
                <template slot-scope="scope">
                    <span>{{$utils.formatDate(scope.row.orderCreateTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="lastAuditingTime"
                    label="最终审批时间"
                    width="">
                <template slot-scope="scope">
                    <span>{{$utils.formatDate(scope.row.lastAuditingTime)}}</span>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
<!--        <el-pagination-->
<!--                @size-change="handleSizeChange"-->
<!--                @current-change="handleCurrentChange"-->
<!--                :current-page="queryForm.pageNo"-->
<!--                :page-sizes="pageSizes"-->
<!--                :page-size="queryForm.pageSize"-->
<!--                layout="total, sizes, prev, pager, next"-->
<!--                :total="total">-->
<!--        </el-pagination>-->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            prev-text="上一页"
            next-text="下一页"
            layout="prev, next">
        </el-pagination>
    </div>
</template>

<script>
    import moment from 'moment'
    import exportExcel from '~/components/exportExcel2.vue'
    export default {
        components: {exportExcel},
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    pageSize: 50,
                    pageNo: 1,
                    school_id: '',
                    shop_id: '',
                    orderId: '',
                    linkmanTel: '',
                    startDate:'',
                    endDate:'',
                    startDate1:'',
                    endDate1:'',
                    refundStartDate: '',
                    refundEndDate: '',
                    responsibility:'',
                    needRefund: '',
                    reasonCode:'',
                    approveStatus:'',
                    isAppeal:'',
                    is_authneed: true
                },
                dateType: 1,
                tableData: [],//表格数据
                total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: false,//表格是否显示加载效果
                rules: {},
                shops: JSON.parse(localStorage.getItem('shops')),
                shopList: [],
                exportParams:{},
                filename: '退款列表',
                tableTitle: ['订单号','交易号','学校名称','店铺名称','用户名','用户手机','退款类型','退款原因','详细描述','审核状态','退款方','审核结果','申请金额','退款金额','配送费扣除','商家结算款扣除','申请退款时间','退款完成时间','下单时间','最终审批时间'],
                fieldName: ['orderId','logTransId','schoolName','supplierShortName','userName','linkmanTel','refundType','reason','complaintContent','approveStatus','responsibilityIdentification','auditingResult','refundAmount','realRefundAmount','cutDeliveryFee','settlePrice','createTime','refundDate','orderCreateTime','lastAuditingTime'],

            }
        },
        created(){
            //设置最近一周时间
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.startDate1 = new Date(day.getFullYear(),day.getMonth(),day.getDate(),0,0,0);
            this.queryForm.endDate1 = new Date();
            if(this.queryForm.school_id){
                this.getShopsInSchool(this.queryForm);
            }
            this.fetchData();
        },
        computed: {
            operation: function(){
                return this.$store.getters.operation
            }
        },
        methods: {
            changeDateType(type) {
                if(type == 1){
                    var day = new Date();
                    day.setTime(day.getTime()-7*24*60*60*1000);
                    this.queryForm.startDate1 = new Date(day.getFullYear(),day.getMonth(),day.getDate(),0,0,0);
                    this.queryForm.endDate1 = new Date();
                    this.queryForm.refundStartDate = '';
                    this.queryForm.refundEndDate = '';
                }else{
                    this.queryForm.startDate1 = '';
                    this.queryForm.endDate1 = '';
                }
            },
            //抓取列表数据
            fetchData() {
                if(this.queryForm.startDate1) this.queryForm.startDate = moment(this.queryForm.startDate1).format('YYYYMMDD');
                else this.queryForm.startDate = '';
                if(this.queryForm.endDate1) this.queryForm.endDate = moment(this.queryForm.endDate1).format('YYYYMMDD');
                else this.queryForm.endDate = '';
                if(this.queryForm.startDate > this.queryForm.endDate){
                    this.$message.warning('开始时间不能大于结束时间');
                    return;
                }
                if((this.queryForm.refundStartDate && !this.queryForm.refundEndDate) || (!this.queryForm.refundStartDate && this.queryForm.refundEndDate)){
                    this.$message.warning('请选择退款时间');
                    return;
                }
                if(this.queryForm.refundStartDate > this.queryForm.refundEndDate){
                    this.$message.warning('开始时间不能大于结束时间');
                    return;
                }
                let params = {...this.queryForm};
                delete params.startDate1;
                delete params.endDate1;
                this.exportParams = {...params};
                this.exportParams.pageSize = 99999;
                this.exportParams.pageNo = 1;
                this.loading = true;
                this.$apiJava.post(this.$apiUrl.adminreFundlist,params,(res)=>{
                    this.loading = false;
                    if(res.data){
                        // this.total = parseInt(res.data.total) || 0;
                        this.tableData = res.data.list || [];
                    }else{
                        // this.total = 0;
                        this.tableData = [];
                    }
                },(res)=>{
                    this.$message.warning(res.msg);
                    this.loading = false;
                    this.tableData = [];
                },'oc')
            },
              remoteShopMethod(query){
                if (query !== '') {
                  this.shopList = [];
                  var arr = [];
                  let len = this.shops.length;
                  var reg = new RegExp(query);
                  for(var i=0;i<len;i++){
                    //如果字符串中不包含目标字符会返回-1
                    if(this.shops[i].name.match(reg)){
                      this.shopList.push(this.shops[i]);
                    }
                  }
                } else {
                  this.shopList = [];
                }
              },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.queryForm.pageNo = 1;
                var day = new Date();
                day.setTime(day.getTime()-7*24*60*60*1000);
                this.queryForm.startDate1 = new Date(day.getFullYear(),day.getMonth(),day.getDate(),0,0,0);
                this.queryForm.endDate1 = new Date();
                this.queryForm.pageSize = 50;
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.fetchData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.fetchData();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .pagetitle{
        font-size: 18px;
        color: #000000;
    }
    .warp50{
        padding-top: 10px;
        width: 100%;
    }
    .evaimg{
        width: 100px;
        height: 100px;
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;
    }
    .complainBut{
        margin-left: 50%;
    }
    .el-dialog__body .el-form-item{
        margin-bottom: 0;
    }
    .el-dialog__body .line{
        margin-bottom: 5px;
    }
    .mb20{
        margin-bottom: 0;
    }
    .noteBox{
        margin-left: 70px;
        margin-top: 5px;
    }
    .noteCircle{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #000000;
        text-align: center;
        display: inline-block;
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// list.vue?744ee934